import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { RouteComponentProps } from 'react-router';
import Slider from 'react-slick';
import { t } from '../../../../locales';
import { isApp } from '../../../../utils/';
import {
  hideCloseButton,
  showCloseButton,
  controlTopBar,
  setNavigationBarTitle,
} from '../../../../utils/AppUtils';
import { fetchAxaGoalDashboardPolicy } from '../../actions/dashboardAction';
import {
  showAxaGoalSeeAllPolicy,
  showAxaGoalSupport,
} from '../../actions/vhisAction';
import { openDisclaimer } from '../../../../modules/emma-common/actions';
import DashboardCard from '../../components/DashboardCard';
import { EmmaFactory } from '@axa-asia/hk-emma-js';
import { getLanguage } from '../../../../selectors/userSelectors';
import {
  getDashboardLoading,
  getDashboardPoliciesData,
} from '../../selectors/dashboardSelector';
// import image
import AxaGoalImg from '../../../../assets/images/vhis/dashboard/axa-goal@3x.png';
import ShapeImg from '../../../../assets/images/vhis/dashboard/shape@3x.png';
import SupportImg from '../../../../assets/images/vhis/dashboard/support@3x.png';
import ArrowWhiteImg from '../../../../assets/images/vhis/dashboard/arrow-white.svg';

import LoadingView from '../../../../components/LoadingView';
import BackNavButtonContainer from '../../../emma-customer-profile/containers/BackNavButtonContainer';
import VhisModalView from '../../components/VhisModalView';
import EmmaModalView from '../../../../components/EmmaModalView/EmmaModalView';
import HealthKeeperModalView from '../../../../components/EmmaModalView/HealthKeeperModal/HealthKeeperModalView';

import { NUMBER_OF_MAX_CARD_SHOWING } from '../../constants/constants';

import './style.scss';
import { SmallButton } from '@axa-asia/emma-stylesheet';

interface DashboardProps {
  isLoading: boolean;
  lang: string;
  dashboardPolicies: any;
  policyTitle: string;
  policyLength: number;
  isShowViewAllCard: boolean;
  isShowTrackingDevice: boolean;
  onFetchAxaGoalDashboardPolicy: (payload: any) => void;
  onPressSeeAllButton: () => void;
  onOpenWellnessCompanionDisclaimer: () => void;
  onShowAxaGoalSupport: () => void;
}

interface DashboardState {
  arrowClass: string;
}

class Dashboard extends Component<
  DashboardProps & RouteComponentProps,
  DashboardState
> {
  constructor(props: any) {
    super(props);
    this.state = {
      arrowClass: 'axa-goal-dashboard-card-slider-arrow-first',
    };
    this.goToSupportPage = this.goToSupportPage.bind(this);
    this.goToTrackingDevicePage = this.goToTrackingDevicePage.bind(this);
    this.onPressSeeAllButton = this.onPressSeeAllButton.bind(this);
    this.goToWellnessCompanionPage = this.goToWellnessCompanionPage.bind(this);
    controlTopBar(false);
    setNavigationBarTitle(' ');
  }

  componentDidMount() {
    this.props.onFetchAxaGoalDashboardPolicy({});
    hideCloseButton();
  }

  componentWillUnmount() {
    controlTopBar(true);
    showCloseButton();
  }

  goToSupportPage() {
    this.props.onShowAxaGoalSupport();
  }

  onPressSeeAllButton() {
    this.props.onPressSeeAllButton();
  }

  goToTrackingDevicePage() {
    EmmaFactory.createInstance().then((e) => {
      e.instance &&
        e.instance.goTo &&
        e.instance.goTo('aktivo-onboarding/tracker');
    });
  }

  goToWellnessCompanionPage() {
    const { onOpenWellnessCompanionDisclaimer } = this.props;
    if (isApp()) {
      EmmaFactory.createInstance().then((e) => {
        e.instance &&
          e.instance.goTo &&
          e.instance.goTo('emma-common?disclaimer=healthKeeperChallengeNew');
      });
    } else {
      onOpenWellnessCompanionDisclaimer();
    }
  }

  render() {
    const {
      isLoading,
      dashboardPolicies,
      policyTitle,
      policyLength,
      isShowViewAllCard,
      isShowTrackingDevice,
    } = this.props;
    const { arrowClass } = this.state;
    const sliderSettings = {
      dots: true,
      infinite: false,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      afterChange: (index: number) => {
        this.setState({
          arrowClass:
            index === 0
              ? 'axa-goal-dashboard-card-slider-arrow-first'
              : index === policyLength - 1
              ? 'axa-goal-dashboard-card-slider-arrow-last'
              : '',
        });
      },
    };
    return isLoading ? (
      <LoadingView />
    ) : (
      <div className="axa-goal-dashboard">
        <EmmaModalView />
        <VhisModalView />
        <HealthKeeperModalView />
        <div className="axa-goal-dashboard-top">
          <div>
            <BackNavButtonContainer isShowBackButton={!isApp()} />
          </div>
          <img
            className="axa-goal-dashboard-top-img"
            title=""
            alt=""
            src={AxaGoalImg}
          />
          <div>{t('AXA_GOAL_DASHBOARD_WELCOME')}</div>
        </div>
        <div className="axa-goal-dashboard-content">
          <div
            className={`axa-goal-dashboard-card-wrap ${
              policyLength === 1 && 'axa-goal-dashboard-card-wrap-one'
            }`}
          >
            <div className="axa-goal-dashboard-card-wrap-top">
              <div>{policyTitle}</div>
              {policyLength > 1 && (
                <div
                  className="axa-goal-dashboard-card-see-all"
                  onClick={this.onPressSeeAllButton}
                  data-enable-ga
                  data-ga-type="button"
                >
                  <span>
                    {t('AXA_GOAL_DASHBOARD_SEE_ALL').replace(
                      '{policies}',
                      policyLength.toString(),
                    )}
                  </span>
                  <img title="" alt="" src={ArrowWhiteImg} />
                </div>
              )}
            </div>
            <div className={`axa-goal-dashboard-card-slider ${arrowClass}`}>
              {policyLength === 1 ? (
                <div className="axa-goal-dashboard-card-slider-card emma-deprecated-slick">
                  <DashboardCard {...dashboardPolicies[0]} />
                </div>
              ) : (
                <Slider {...sliderSettings}>
                  {dashboardPolicies.map((item: any, index: number) => {
                    if (index >= NUMBER_OF_MAX_CARD_SHOWING) {
                      return '';
                    }
                    return (
                      <div className="axa-goal-dashboard-card-slider-card">
                        <DashboardCard {...item} />
                      </div>
                    );
                  })}
                  {(isShowViewAllCard || policyLength === 0) && (
                    <div className="axa-goal-dashboard-card-slider-card">
                      <div className="axa-goal-dashboard-card axa-goal-dashboard-card-slider-view-all">
                        {isShowViewAllCard && (
                          <div>
                            <div className="axa-goal-dashboard-card-slider-view-all-txt">
                              {t('AXA_GOAL_DASHBOARD_VIEW_ALL_TEXT')}
                            </div>
                            <div className="axa-goal-dashboard-card-slider-view-all-button">
                              <button
                                className="emma-stylesheet-primary-default-button"
                                onClick={this.onPressSeeAllButton}
                                data-enable-ga
                                data-ga-type="button"
                              >
                                {t('AXA_GOAL_DASHBOARD_VIEW_ALL_BUTTON')}
                              </button>
                            </div>
                          </div>
                        )}
                        {policyLength === 0 && (
                          <div>
                            <div className="axa-goal-dashboard-card-slider-view-all-txt">
                              {t('AXA_GOAL_DASHBOARD_NO_POLICY_TEXT')}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </Slider>
              )}
            </div>
          </div>

          {isShowTrackingDevice ? (
            <div className="axa-goal-dashboard-service">
              <div
                className="axa-goal-dashboard-tracking-device"
                data-enable-ga
                data-ga-type="button"
                onClick={this.goToTrackingDevicePage}
              >
                <img
                  className="axa-goal-dashboard-tracking-device-img"
                  title=""
                  alt=""
                  src={ShapeImg}
                />
                <span>{t('AXA_GOAL_DASHBOARD_TRACKING_DEVICE')}</span>
              </div>
              <div
                className="axa-goal-dashboard-support-1"
                data-enable-ga
                data-ga-type="button"
                onClick={this.goToSupportPage}
              >
                <img
                  className="axa-goal-dashboard-support-img"
                  title=""
                  alt=""
                  src={SupportImg}
                />
                <span>{t('AXA_GOAL_DASHBOARD_SUPPORT_LOWERCASE')}</span>
              </div>
            </div>
          ) : (
            <div
              className="axa-goal-dashboard-support-2"
              data-enable-ga
              data-ga-type="button"
              onClick={this.goToSupportPage}
            >
              <img
                className="axa-goal-dashboard-support-img"
                title=""
                alt=""
                src={SupportImg}
              />
              <div>
                <div className="axa-goal-dashboard-support-2-support">
                  {t('AXA_GOAL_DASHBOARD_SUPPORT_LOWERCASE')}
                </div>
                <div className="axa-goal-dashboard-support-2-txt">
                  {t('AXA_GOAL_DASHBOARD_SUPPORT_TEXT')}
                </div>
              </div>
            </div>
          )}

          <div className="axa-goal-dashboard-bottom">
            <div className="axa-goal-dashboard-banner">
              <div>
                <div>{t('AXA_GOAL_DASHBOARD_BANNER_TITLE')}</div>
                <div className="axa-goal-dashboard-banner-txt">
                  {t('AXA_GOAL_DASHBOARD_BANNER_TEXT')}
                </div>
                <div>
                  <SmallButton
                    varient="white"
                    data-enable-ga
                    data-ga-type="button"
                    onClick={this.goToWellnessCompanionPage}
                  >
                    {t('AXA_GOAL_DASHBOARD_BANNER_BUTTON')}
                  </SmallButton>
                </div>
              </div>
            </div>
            <div
              className="axa-goal-dashboard-support-3"
              data-enable-ga
              data-ga-type="button"
              onClick={this.goToSupportPage}
            >
              <div className="axa-goal-dashboard-support-img-wrap">
                <img
                  className="axa-goal-dashboard-support-img"
                  title=""
                  alt=""
                  src={SupportImg}
                />
              </div>
              <div className="axa-goal-dashboard-support-3-support">
                {t('AXA_GOAL_DASHBOARD_SUPPORT')}
              </div>
              <div className="axa-goal-dashboard-support-3-txt">
                {t('AXA_GOAL_DASHBOARD_SUPPORT_TEXT')}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  static mapStateToProps(state: any, ownProps: any) {
    const lang = getLanguage(state);
    const dashboardPoliciesData = getDashboardPoliciesData(state);
    const isLoading = getDashboardLoading(state);
    const {
      policyTitle,
      dashboardPolicies,
      policyLength,
      isShowViewAllCard,
      isShowTrackingDevice,
    } = dashboardPoliciesData;
    return {
      isLoading,
      lang,
      dashboardPolicies,
      policyTitle,
      policyLength,
      isShowViewAllCard,
      isShowTrackingDevice,
    };
  }

  static mapDispatchToProps(dispatch: any) {
    return {
      onFetchAxaGoalDashboardPolicy: (payload: any) =>
        dispatch(fetchAxaGoalDashboardPolicy(payload)),
      onPressSeeAllButton: () => dispatch(showAxaGoalSeeAllPolicy()),
      onOpenWellnessCompanionDisclaimer: () => {
        dispatch(openDisclaimer('health-keeper'));
      },
      onShowAxaGoalSupport: () => dispatch(showAxaGoalSupport()),
    };
  }
}

export default connect(
  Dashboard.mapStateToProps,
  Dashboard.mapDispatchToProps,
)(Dashboard);
